import functions from './functions.js';
import listResults from './list/listResults.js';
import pagination from './list/pagination.js';
import Slider from "./Slider";

$(() => {
    list.init();
})

const list = {
    $form: null,
    form: null,
    $formFilters: null,
    formFilters: null,
    filters: null,
    $sortBy: null,
    sortBy: null,
    defaults: {
        _page: 1,
        perPage: 10,
        lang: functions.getLang(),
        objectName: null,
        objectTypeId: null,
        dateFrom: null,
        dateTo: null,
        guests: '2,0,0',
        rooms: '',
        bathrooms: '',
        distanceBeach: '',
        seaView: '',
        pool: '',
        parking: '',
        grill: '',
        pets: '',
        sortBy: null
    },
    params: {},
    hiddenParams: ['_page', 'perPage'],
    total: null,
    $listItems: null,
    loading: false,
    init() {
        list.$form = $('.search-form');
        list.form = list.$form[0];

        if(! list.form) return;

        list.$listItems = $('.list-items');

        list.$formFilters = $('.filter-form');
        list.formFilters = list.$formFilters[0] ? list.$formFilters[0] : null;

        list.filters = list.$form.attr('data-filters');

        if($('[name=objectTypeId]').attr('disabled')) {
            list.defaults.objectTypeId = $('[name=objectTypeId]').val();
        }

        list.getParams();
        functions.setFormData(list.form, list.params);
        if(list.formFilters) {
            functions.setFormData(list.formFilters, list.params);
        }

        list.initComponents();

        list.params.sortBy = list.$form.attr('data-sortby') ? list.$form.attr('data-sortby') : list.params.sortBy;

        //if(list.params.isHome || ! list.defaults.objectTypeId) {
        if(! $('.search-home')[0]) {
            list.find();
        }
        //}

        list.$form.on('submit', e => {
            e.preventDefault();
            list.params = $.extend(list.params, list.getParams(), functions.getFormData(list.$form));
            list.params.sortBy = list.params.objectTypeId == 1 ||list.params.objectTypeId == 53 ? null : '16:ASC';
            if(list.filters) {
                functions.setUrlData(list.params, true);
            } else {
                location = list.$form.attr('data-listUrl') + '#isHome=1&' + $.param(list.params);
            }
        });

        list.$formFilters.on('submit', e => {
            e.preventDefault();

            list.params = $.extend(list.params, list.defaults, functions.getFormData(list.$formFilters));

            functions.setUrlData(list.params, true);

            $('#filters').collapse('hide');
        });

        $('.btn-clear').on('click', e => {
            e.preventDefault();

            functions.setFormData(list.formFilters, list.defaults);

            list.params = $.extend(list.params, list.defaults, functions.getFormData(list.$formFilters));
            
            functions.setUrlData(list.params, true);

            $('#filters').collapse('hide');
        });

        $(window).on('hashchange', e => {
            list.getParams();
            list.find();
        });
    },
    getParams() {
        list.params = $.extend(list.params, list.defaults, functions.getUrlData(true));
    },
    find() {

        list.setLoadingMode();

        $.get('/services/list', list.params).then(response => {
            response = JSON.parse(response);

            list.unsetLoadingMode();

            list.total = response.total;

            list.$listItems.html(response.html);
            if (list.total != 0) {
                //list.$listItems.html(response.html);

                $('.paginate').html(pagination({
                    currentPage: list.params._page,
                    total: list.total,
                    perPage: list.defaults.perPage,
                }));
            }

            //list.$listItems.html(response.html);
            listResults.getResults(list.total, list.params._page, list.defaults.perPage);

            list.initComponents();

        });
    },
    paginate(page) {
        if (page != list.params._page) {
            list.params._page = page;
        }

        functions.setUrlData(list.params, true);
    },
    initComponents() {
        functions.setFormData($('.form-objectName')[0], list.params);
        functions.setFormData($('.form-objectName')[1], list.params);

        list.$sortBy = $('[name="sortBy"]');
        list.sortBy = list.$sortBy[0] ? list.$sortBy[0] : null;

        /*if(! list.params.sortBy) {
            list.params.sortBy = list.$sortBy.val();
        }*/

        if(list.sortBy && list.params.sortBy) {
            list.$sortBy.val(list.params.sortBy);
        }

        list.$sortBy.on('change', e => {
            list.params = $.extend(list.params, list.getParams(), functions.getFormData(list.$sortBy));
            functions.setUrlData(list.params, true, true);
        });

        const $dataHref = $('[data-href]');
        if($dataHref[0]) {
            $dataHref.on('click', e => {
                const tr = $(e.target).parents('[data-href]');
                location = tr.attr('data-href');
            });
        }

        let cardSlider = [];
        $('[id^=card-slider]').each((i, elem) => {
            cardSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
            });
        });

        // register paginate
        $('[data-page]').on('click', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });
    },
    setLoadingMode() {
        if(! list.loading) {
            list.loading = true;

            // form submit btn
            (list.$form).find('button').prop('disabled', true);

            if ( ! $('.spinner').length) {
                $('<div class="spinner d-none"><div class="spinner-border text-secondary" role="status" style="width: 4rem; height: 4rem;"><span class="sr-only">Loading...</span></div></div>').insertBefore('.list-items');
            }

            $('.spinner').removeClass('d-none');
            $('.spinner').addClass('d-flex justify-content-center');
            list.$listItems.addClass('d-none');
            $('.paginate').addClass('d-none');
        }
    },
    unsetLoadingMode() {
        if(list.loading) {
            list.loading = false;

            // form submit btn
            (list.$form).find('button').prop('disabled', false);

            $('.spinner').removeClass('d-flex justify-content-center');
            $('.spinner').addClass('d-none');
            list.$listItems.removeClass('d-none');
            $('.paginate').removeClass('d-none');

            functions.scrollToElement(list.$listItems, 100);
        }
    },
}